import { Button } from 'primereact/button';
import { RequestStatus } from '@/shared/model/requestStatus';
import classes from './RequestState.module.scss';

export interface RequestErrorProps {
    message: string;
    onRetry?: () => void | Promise<void>;
    retryLabel?: string;
    compact?: boolean;
}

export interface RequestLoadingProps {
    message?: string;
}

export interface RequestErrorBannerProps extends Pick<RequestErrorProps, 'onRetry' | 'retryLabel' | 'compact'> {
    status: RequestStatus;
    error: string | null;
    fallbackMessage: string;
}

/** Отображает сообщение об ошибке запроса. */
export const RequestError = (
    {
        message,
        onRetry,
        retryLabel = 'Повторить',
        compact = false,
    }: RequestErrorProps
) => (
    <div
        className={`${classes.state} ${classes.error} ${compact
            ? classes.compact
            : ''}`}
        role="alert"
    >
        <span>{message}</span>
        {onRetry && (
            <Button
                type="button"
                label={retryLabel}
                outlined={compact}
                onClick={() => void onRetry()}
            />
        )}
    </div>
);

/** Отображает индикатор загрузки. */
export const RequestLoading = ({ message = 'Загрузка данных...' }: RequestLoadingProps) => (
    <div
        className={classes.state}
        role="status"
        aria-live="polite"
    >
        <span>{message}</span>
    </div>
);

/** Показывает ошибку запроса при неудачной загрузке. */
export const RequestErrorBanner = (
    {
        status,
        error,
        fallbackMessage,
        onRetry,
        retryLabel,
        compact = true,
    }: RequestErrorBannerProps
) => status === RequestStatus.Error
        ? <RequestError
            message={error ?? fallbackMessage}
            onRetry={onRetry}
            retryLabel={retryLabel}
            compact={compact}
        />
        : null;

/** Отображает сообщение об отсутствии данных. */
export const RequestEmpty = ({ message }: { message: string }) => (
    <div
        className={classes.state}
        role="status"
    >
        {message}
    </div>
);
